export const encodeToParams = (object = {}) => {
  const url = new URLSearchParams();
  Object.keys(object).forEach((key) => {
    if (object[key]) {
      url.set(key, object[key]);
    }
  });
  return url.toString();
};
